var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAboutUsIllustration(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 500 500",
    style: {
      enableBackground: "new 0 0 500 500"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "BACKGROUND"
  }, /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#FFFFFF"
    },
    width: 500,
    height: 500
  })), /*#__PURE__*/React.createElement("g", {
    id: "OBJECTS"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#CADFF5"
    },
    d: "M221.917,181.972c-15.132-54.893-83.321-72.576-122.4-31.551c-0.561,0.589-1.122,1.188-1.682,1.797 C41.81,213.119,68.277,363.199,185.2,401.238c116.923,38.039,238.539-31.424,245.371-93.518 c6.832-62.095-47.11-81.606-130.823-64.242C252.452,253.287,231.337,216.144,221.917,181.972z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#CADFF5"
    },
    d: "M74.89,311.77c-9.477-12.704-23.774-10.156-26.925,5.097c-1.041,5.041-0.806,11.346,1.746,19.173 c9.721,29.82,29.442,38.071,39.467,18.879C95.366,343.072,84.282,324.36,74.89,311.77z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#CADFF5"
    },
    d: "M436.604,313.141c-0.576,11.328,9.621,17.88,19.356,12.194c3.218-1.879,6.284-5.067,8.685-10.256 c9.147-19.767,1.078-34.515-14.944-30.662C439.813,286.794,437.175,301.914,436.604,313.141z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#CADFF5"
    },
    d: "M56.313,218.895c-1.657,7.5-9.491,9.948-14.826,4.489c-1.763-1.805-3.194-4.436-3.83-8.255 c-2.425-14.548,5.49-22.729,15.259-17.339C58.945,201.117,57.955,211.462,56.313,218.895z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#CADFF5"
    },
    d: "M322.042,128.282c0,1.239-0.505,2.368-1.327,3.186c-0.812,0.823-1.942,1.327-3.181,1.327h-96.475 c-2.478,0-4.508-2.03-4.508-4.513c0-1.239,0.505-2.368,1.327-3.185c0.812-0.823,1.942-1.328,3.181-1.328h4.56 c1.801-4.185,5.96-7.11,10.801-7.11c3.258,0,6.205,1.327,8.339,3.467c2.842-4.82,8.084-8.058,14.086-8.058 c1.65,0,3.238,0.25,4.737,0.703c3.139-5.903,9.344-9.922,16.496-9.922c8.589,0,15.814,5.799,17.995,13.69 c1.582-0.791,3.368-1.244,5.262-1.244c5.356,0,9.875,3.576,11.296,8.474h2.905C320.012,123.769,322.042,125.8,322.042,128.282z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#CADFF5"
    },
    d: "M379.662,207.88c0,1.162-0.474,2.222-1.245,2.989c-0.762,0.772-1.822,1.245-2.984,1.245h-90.523 c-2.325,0-4.23-1.905-4.23-4.235c0-1.163,0.474-2.222,1.246-2.989c0.762-0.772,1.822-1.246,2.984-1.246h4.279 c1.69-3.927,5.592-6.671,10.135-6.671c3.057,0,5.822,1.245,7.824,3.253c2.667-4.523,7.585-7.561,13.216-7.561 c1.548,0,3.038,0.234,4.445,0.659c2.945-5.538,8.767-9.309,15.478-9.309c8.059,0,14.838,5.441,16.885,12.846 c1.485-0.742,3.16-1.167,4.938-1.167c5.026,0,9.265,3.355,10.599,7.951h2.725C377.757,203.645,379.662,205.55,379.662,207.88z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3B73A9"
    },
    d: "M402.166,139.157c-3.508,0-6.362-2.854-6.362-6.362s2.854-6.362,6.362-6.362 c3.508,0,6.362,2.854,6.362,6.362S405.673,139.157,402.166,139.157z M402.166,128.429c-2.408,0-4.366,1.958-4.366,4.366 c0,2.407,1.959,4.366,4.366,4.366c2.407,0,4.366-1.959,4.366-4.366C406.531,130.388,404.573,128.429,402.166,128.429z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FD7C78"
    },
    d: "M425.068,161.477c-3.508,0-6.362-2.854-6.362-6.362c0-3.508,2.854-6.362,6.362-6.362 c3.508,0,6.362,2.854,6.362,6.362C431.43,158.623,428.576,161.477,425.068,161.477z M425.068,150.749 c-2.407,0-4.366,1.959-4.366,4.366c0,2.407,1.959,4.366,4.366,4.366c2.407,0,4.366-1.959,4.366-4.366 C429.434,152.707,427.475,150.749,425.068,150.749z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3B73A9"
    },
    d: "M432.928,182.15c-0.551,0-0.998-0.447-0.998-0.998v-4.401c0-0.551,0.447-0.998,0.998-0.998 c0.551,0,0.998,0.447,0.998,0.998v4.401C433.926,181.703,433.479,182.15,432.928,182.15z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3B73A9"
    },
    d: "M432.928,189.852c-0.551,0-0.998-0.447-0.998-0.998v-4.401c0-0.551,0.447-0.998,0.998-0.998 c0.551,0,0.998,0.447,0.998,0.998v4.401C433.926,189.405,433.479,189.852,432.928,189.852z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3B73A9"
    },
    d: "M439.106,183.801h-3.953c-0.551,0-0.998-0.447-0.998-0.998c0-0.551,0.447-0.998,0.998-0.998 h3.953c0.551,0,0.998,0.447,0.998,0.998C440.103,183.354,439.657,183.801,439.106,183.801z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3B73A9"
    },
    d: "M430.704,183.801h-3.953c-0.551,0-0.998-0.447-0.998-0.998c0-0.551,0.447-0.998,0.998-0.998 h3.953c0.551,0,0.998,0.447,0.998,0.998C431.702,183.354,431.255,183.801,430.704,183.801z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#015288"
    },
    d: "M397.799,157.49c-0.551,0-0.998-0.447-0.998-0.998v-4.401c0-0.551,0.447-0.998,0.998-0.998 c0.551,0,0.998,0.447,0.998,0.998v4.401C398.797,157.043,398.35,157.49,397.799,157.49z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#015288"
    },
    d: "M397.799,165.192c-0.551,0-0.998-0.447-0.998-0.998v-4.401c0-0.551,0.447-0.998,0.998-0.998 c0.551,0,0.998,0.447,0.998,0.998v4.401C398.797,164.745,398.35,165.192,397.799,165.192z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#015288"
    },
    d: "M403.977,159.141h-3.953c-0.551,0-0.998-0.447-0.998-0.998c0-0.551,0.447-0.998,0.998-0.998 h3.953c0.551,0,0.998,0.447,0.998,0.998C404.975,158.694,404.528,159.141,403.977,159.141z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#015288"
    },
    d: "M395.576,159.141h-3.953c-0.551,0-0.998-0.447-0.998-0.998c0-0.551,0.447-0.998,0.998-0.998 h3.953c0.551,0,0.998,0.447,0.998,0.998C396.573,158.694,396.127,159.141,395.576,159.141z"
  }))))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3B73A9"
    },
    d: "M98.104,124.529c0-3.508,2.854-6.362,6.362-6.362c3.508,0,6.362,2.854,6.362,6.362 c0,3.508-2.854,6.362-6.362,6.362C100.958,130.891,98.104,128.037,98.104,124.529z M100.1,124.529 c0,2.408,1.959,4.366,4.366,4.366c2.407,0,4.366-1.959,4.366-4.366s-1.959-4.366-4.366-4.366 C102.058,120.163,100.1,122.121,100.1,124.529z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FD7C78"
    },
    d: "M72.555,148.778c0-3.508,2.854-6.362,6.362-6.362c3.508,0,6.362,2.854,6.362,6.362 c0,3.508-2.854,6.362-6.362,6.362C75.409,155.14,72.555,152.286,72.555,148.778z M74.551,148.778 c0,2.408,1.959,4.366,4.366,4.366s4.366-1.958,4.366-4.366s-1.958-4.366-4.366-4.366S74.551,146.371,74.551,148.778z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3B73A9"
    },
    d: "M59.328,157.706c0.551,0,0.998-0.447,0.998-0.998v-4.401c0-0.551-0.447-0.998-0.998-0.998 c-0.551,0-0.998,0.447-0.998,0.998v4.401C58.33,157.259,58.777,157.706,59.328,157.706z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3B73A9"
    },
    d: "M59.328,165.408c0.551,0,0.998-0.447,0.998-0.998v-4.401c0-0.551-0.447-0.998-0.998-0.998 c-0.551,0-0.998,0.447-0.998,0.998v4.401C58.33,164.961,58.777,165.408,59.328,165.408z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3B73A9"
    },
    d: "M53.151,159.356h3.953c0.551,0,0.998-0.447,0.998-0.998c0-0.551-0.447-0.998-0.998-0.998 h-3.953c-0.551,0-0.998,0.447-0.998,0.998C52.153,158.91,52.6,159.356,53.151,159.356z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3B73A9"
    },
    d: "M61.552,159.356h3.953c0.551,0,0.998-0.447,0.998-0.998c0-0.551-0.447-0.998-0.998-0.998 h-3.953c-0.551,0-0.998,0.447-0.998,0.998C60.554,158.91,61.001,159.356,61.552,159.356z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#015288"
    },
    d: "M82.323,123.877c0.551,0,0.998-0.447,0.998-0.998v-4.401c0-0.551-0.447-0.998-0.998-0.998 c-0.551,0-0.998,0.447-0.998,0.998v4.401C81.325,123.43,81.772,123.877,82.323,123.877z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#015288"
    },
    d: "M82.323,131.578c0.551,0,0.998-0.447,0.998-0.998v-4.401c0-0.551-0.447-0.998-0.998-0.998 c-0.551,0-0.998,0.447-0.998,0.998v4.401C81.325,131.131,81.772,131.578,82.323,131.578z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#015288"
    },
    d: "M76.146,125.527h3.953c0.551,0,0.998-0.447,0.998-0.998s-0.447-0.998-0.998-0.998h-3.953 c-0.551,0-0.998,0.447-0.998,0.998S75.595,125.527,76.146,125.527z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#015288"
    },
    d: "M84.547,125.527H88.5c0.551,0,0.998-0.447,0.998-0.998s-0.447-0.998-0.998-0.998h-3.953 c-0.551,0-0.998,0.447-0.998,0.998S83.996,125.527,84.547,125.527z"
  }))))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FD7C78"
    },
    d: "M332.392,147.74v18.411c0,2.434-1.975,4.408-4.408,4.408h-33.429l-10.092,3.621 c-1.036,0.372-2.029-0.647-1.631-1.671l3.818-9.859v-14.91c0-2.434,1.975-4.408,4.41-4.408h36.925 C330.418,143.331,332.392,145.306,332.392,147.74z"
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.5
    }
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#D64E5A"
    },
    d: "M325.345,152.949h-30.668c-0.672,0-1.216-0.545-1.216-1.216l0,0c0-0.672,0.545-1.216,1.216-1.216 h30.668c0.672,0,1.216,0.545,1.216,1.216l0,0C326.562,152.404,326.017,152.949,325.345,152.949z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#D64E5A"
    },
    d: "M325.345,157.848h-30.668c-0.672,0-1.216-0.545-1.216-1.217l0,0c0-0.672,0.545-1.216,1.216-1.216 h30.668c0.672,0,1.216,0.545,1.216,1.216l0,0C326.562,157.303,326.017,157.848,325.345,157.848z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#D64E5A"
    },
    d: "M325.345,162.747h-30.668c-0.672,0-1.216-0.545-1.216-1.216l0,0c0-0.672,0.545-1.217,1.216-1.217 h30.668c0.672,0,1.216,0.545,1.216,1.217l0,0C326.562,162.202,326.017,162.747,325.345,162.747z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#CADFF5"
    },
    d: "M204.825,101.919c0.108,0.027,0.223,0.028,0.338-0.002c1.219-0.319,1.925-0.449,1.932-0.45 c0.369-0.067,0.614-0.42,0.547-0.789c-0.067-0.369-0.42-0.614-0.789-0.548c-0.03,0.006-0.758,0.138-2.035,0.473 c-0.363,0.095-0.58,0.466-0.485,0.829C204.4,101.68,204.593,101.86,204.825,101.919z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#CADFF5"
    },
    d: "M165.369,133.047c-0.633,1.154-1.242,2.35-1.812,3.556c-0.141,0.299-0.472,0.447-0.781,0.369 c-0.042-0.011-0.083-0.025-0.124-0.044c-0.339-0.16-0.484-0.565-0.324-0.904c0.581-1.23,1.203-2.451,1.849-3.629 c0.18-0.329,0.591-0.449,0.922-0.269C165.429,132.305,165.549,132.718,165.369,133.047z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#CADFF5"
    },
    d: "M161.961,140.261c-0.49,1.219-0.956,2.479-1.384,3.746c-0.114,0.338-0.469,0.527-0.81,0.441 c-0.017-0.004-0.034-0.009-0.052-0.015c-0.355-0.12-0.546-0.506-0.426-0.861c0.437-1.291,0.911-2.575,1.411-3.817 c0.14-0.348,0.536-0.517,0.884-0.377C161.933,139.518,162.101,139.913,161.961,140.261z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#CADFF5"
    },
    d: "M156.202,160.156c-0.328-0.083-0.55-0.4-0.506-0.745c0.174-1.352,0.378-2.704,0.608-4.019 c0.065-0.37,0.417-0.617,0.786-0.552c0.374,0.067,0.617,0.417,0.552,0.786c-0.227,1.295-0.428,2.626-0.599,3.958 c-0.048,0.372-0.388,0.635-0.76,0.587C156.256,160.168,156.229,160.163,156.202,160.156z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#CADFF5"
    },
    d: "M158.93,146.987c0.361,0.101,0.573,0.476,0.471,0.837c-0.166,0.596-0.327,1.2-0.477,1.794 c-0.174,0.686-0.341,1.387-0.498,2.084c-0.082,0.366-0.446,0.596-0.812,0.514c-0.006-0.001-0.012-0.003-0.018-0.004 c-0.356-0.09-0.576-0.447-0.495-0.807c0.159-0.709,0.33-1.422,0.507-2.119c0.153-0.605,0.316-1.219,0.486-1.826 c0.099-0.356,0.464-0.566,0.821-0.476C158.919,146.985,158.925,146.986,158.93,146.987z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#CADFF5"
    },
    d: "M167.395,129.61c-0.161,0.255-0.464,0.366-0.741,0.296c-0.068-0.017-0.134-0.045-0.196-0.084 c-0.317-0.2-0.412-0.62-0.211-0.937c0.724-1.146,1.493-2.281,2.285-3.374c0.22-0.304,0.644-0.372,0.949-0.151 c0.303,0.22,0.371,0.645,0.151,0.948C168.856,127.377,168.104,128.488,167.395,129.61z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#CADFF5"
    },
    d: "M201.352,103.074c-1.239,0.424-2.497,0.898-3.738,1.411c-0.141,0.058-0.289,0.066-0.426,0.031 c-0.201-0.051-0.376-0.193-0.461-0.399c-0.143-0.347,0.022-0.744,0.368-0.887c1.267-0.523,2.551-1.008,3.817-1.44 c0.355-0.121,0.741,0.069,0.862,0.423C201.896,102.566,201.707,102.952,201.352,103.074z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#CADFF5"
    },
    d: "M190.421,107.962c-0.158,0.088-0.336,0.106-0.498,0.065c-0.175-0.044-0.332-0.158-0.426-0.327 c-0.183-0.328-0.066-0.741,0.262-0.924c1.182-0.659,2.398-1.292,3.616-1.881c0.338-0.163,0.743-0.022,0.907,0.316 c0.163,0.338,0.022,0.744-0.316,0.907C192.772,106.695,191.58,107.316,190.421,107.962z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#CADFF5"
    },
    d: "M177.539,117.343c-0.175,0.164-0.415,0.218-0.632,0.163c-0.122-0.031-0.236-0.096-0.328-0.194 c-0.256-0.274-0.243-0.704,0.031-0.96c0.986-0.923,2.015-1.829,3.061-2.692c0.289-0.239,0.717-0.198,0.957,0.091 c0.239,0.289,0.198,0.717-0.091,0.956C179.513,115.552,178.504,116.439,177.539,117.343z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#CADFF5"
    },
    d: "M183.692,112.262c-0.17,0.123-0.378,0.157-0.567,0.109c-0.149-0.038-0.285-0.125-0.382-0.259 c-0.22-0.303-0.154-0.728,0.15-0.949c1.09-0.793,2.223-1.565,3.368-2.296c0.316-0.202,0.736-0.109,0.938,0.207 c0.202,0.316,0.109,0.736-0.207,0.938C185.87,110.728,184.76,111.485,183.692,112.262z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#CADFF5"
    },
    d: "M172.074,123.153c-0.173,0.209-0.444,0.288-0.69,0.226c-0.095-0.024-0.186-0.069-0.266-0.135 c-0.289-0.239-0.329-0.667-0.09-0.956c0.862-1.043,1.77-2.071,2.697-3.057c0.257-0.273,0.686-0.287,0.96-0.029 c0.273,0.257,0.287,0.687,0.03,0.96C173.807,121.126,172.919,122.133,172.074,123.153z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FD7C78"
    },
    points: "205.501,97.321 204.127,86 240.134,91.501  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#D64E5A"
    },
    points: "240.135,91.5 206.872,100.203 206.784,100.228 205.113,102.268 205.501,97.321  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#B2304F"
    },
    points: "205.113,102.268 208.102,102.228 206.784,100.228  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FD7C78"
    },
    points: "210.969,99.132 206.783,100.227 213.592,110.554 240.134,91.501  "
  }))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3B73A9"
    },
    d: "M129.078,420.358c-12.745-12.95-38.819-41.508-55.4-73.824 c-24.402-47.563-48.873-43.312-53.674-26.498C9.139,358.084,63.78,399.023,97.927,420.358H129.078z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#015288"
    },
    d: "M118.928,420.358c-19.363-15.197-35.731-32.463-47.107-45.72 c-16.359-19.063-26.214-34.174-26.313-34.327c-0.352-0.542-1.08-0.697-1.623-0.342c-0.545,0.351-0.7,1.078-0.345,1.622 c0.096,0.152,10.021,15.37,26.473,34.547c10.996,12.819,26.632,29.363,45.138,44.221H118.928z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#015288"
    },
    d: "M126.97,404.583c-5.723-11.422-16.575-35.351-20.599-59.733 c-6.012-36.432-23.003-38.8-29.708-28.755c-18.418,27.588,25.721,78.336,39.8,93.358L126.97,404.583z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#01305A"
    },
    d: "M122.971,406.437c-10.749-15.085-18.679-31.454-23.752-43.496 c-6.736-15.99-10.029-28.008-10.061-28.13c-0.117-0.431-0.563-0.686-0.995-0.567c-0.433,0.116-0.688,0.561-0.569,0.994 c0.031,0.12,3.347,12.223,10.12,28.308c5.079,12.063,13.01,28.442,23.762,43.584L122.971,406.437z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3B73A9"
    },
    d: "M377.782,303.492c10.913-12.79,34.608-42.627,48.476-75.52 c19.901-47.206,43.59-44.902,49.387-29.18c14.992,40.662-51.506,91.081-79.233,109.943L377.782,303.492z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#015288"
    },
    d: "M384.339,305.337c19.202-16.791,35.048-36.139,45.713-50.642 c14.263-19.393,22.594-34.541,22.678-34.695c0.297-0.543,0.982-0.744,1.526-0.443c0.546,0.296,0.746,0.98,0.446,1.525 c-0.081,0.152-8.471,15.408-22.814,34.916c-10.535,14.331-26.1,33.363-44.97,50.065L384.339,305.337z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#015288"
    },
    d: "M379.503,287.276c4.648-11.326,13.298-34.973,15.391-58.563 c3.126-35.247,19.193-38.732,26.323-29.614c19.584,25.039-18.949,76.708-31.323,92.076L379.503,287.276z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#01305A"
    },
    d: "M383.459,288.76c9.188-15.188,15.59-31.4,19.571-43.272c5.288-15.764,7.57-27.486,7.593-27.605 c0.081-0.42,0.489-0.696,0.91-0.614c0.422,0.079,0.698,0.487,0.615,0.909c-0.021,0.117-2.32,11.921-7.636,27.779 c-3.987,11.893-10.389,28.115-19.575,43.358L383.459,288.76z"
  }))))), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3B73A9"
    },
    d: "M445.021,340.634c3.415-18.095,9.983-34.598,17.447-27.788c7.471,6.816-4.369,35.001-22.033,50.62 l-4.738,6.75c12.674-11.607,33.065-18.529,38.6-11.974c5.5,6.514-8.491,9.889-21.785,10.841 c-10.119,0.724-16.578,3.518-19.711,5.259l-22.379,31.88c20.123-18.324,52.319-29.216,61.078-18.843 c8.727,10.337-13.474,15.692-34.567,17.202c-15.94,1.141-26.162,5.519-31.174,8.285l-4.462,6.357 c-1.224-0.601-2.444-1.209-3.659-1.824l26.624-37.929c0.155-3.898-0.205-9.409-2.145-16.276 c-3.623-12.826-5.203-27.132,2.793-24.173c6.939,2.568,8.207,18.932,4.186,33.563l9.207-13.117 C440.457,354.924,443.547,348.444,445.021,340.634z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3B73A9"
    },
    d: "M92.444,195.941c-1.805-14.982-6.275-28.835-12.75-23.674c-6.481,5.166,1.662,28.859,15.254,42.594 l3.506,5.778c-9.73-10.183-26.026-16.955-30.91-11.897c-4.853,5.027,6.404,8.55,17.222,10.053 c8.235,1.145,13.364,3.781,15.831,5.376l16.559,27.29c-15.455-16.081-41.187-26.745-48.915-18.741 c-7.7,7.976,10.161,13.567,27.327,15.952c12.972,1.803,21.092,5.941,25.039,8.476l3.302,5.441 c1.033-0.425,2.064-0.855,3.092-1.292l-19.701-32.467c0.086-3.196,0.681-7.683,2.642-13.192 c3.662-10.29,5.735-21.902-0.964-19.918c-5.814,1.721-7.744,15.033-5.254,27.216l-6.813-11.228 C95.397,207.876,93.224,202.408,92.444,195.941z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#01305A"
    },
    d: "M243.352,414.508c0.175-2.91,0.34-5.679,0.492-8.246c0.617-10.495,1.014-17.658,1.014-17.658 l-4.11-0.184l-2.317-0.105l-27.943-1.241c0,0-0.509,8.012-1.108,19.777c-0.123,2.408-0.249,4.973-0.376,7.658H243.352z"
  }))), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#001336"
    },
    d: "M240.747,388.42l4.11,0.184c0,0-0.397,7.164-1.014,17.658 c-10.736,0.895-22.458,1.259-34.465,0.588c0.599-11.765,1.108-19.777,1.108-19.777l27.943,1.241L240.747,388.42z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#001336"
    },
    d: "M239.28,414.508c0.648-11.211,1.18-20.814,1.469-26.088l-2.317-0.104 c-0.29,5.297-0.824,14.944-1.474,26.192H239.28z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#01305A"
    },
    d: "M252.358,414.508h34.349c-0.127-2.685-0.254-5.251-0.376-7.658 c-0.599-11.765-1.108-19.777-1.108-19.777l-27.944,1.241l-2.317,0.105l-4.11,0.184c0,0,0.397,7.164,1.014,17.658 C252.017,408.829,252.182,411.599,252.358,414.508z"
  }))), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#001336"
    },
    d: "M254.962,388.42l-4.11,0.184c0,0,0.397,7.164,1.014,17.658 c10.736,0.895,22.458,1.259,34.465,0.588c-0.599-11.765-1.108-19.777-1.108-19.777l-27.944,1.241L254.962,388.42z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#001336"
    },
    d: "M258.752,414.508c-0.65-11.248-1.184-20.895-1.474-26.192l-2.317,0.104 c0.289,5.273,0.821,14.877,1.469,26.088H258.752z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3B73A9"
    },
    d: "M289.192,383.194c0,3.301-0.008,5.919-0.03,7.686c-7.819,2.105-15.634,3.632-23.448,4.566 c-0.207,0.025-0.417,0.051-0.626,0.076c-0.348,0.04-0.694,0.083-1.037,0.121c-0.088,0.008-0.174,0.018-0.262,0.025 c-1.358,0.146-2.706,0.278-4.064,0.391c-2.817,0.232-6.914,0.432-9.731,0.51l-2.185-13.014l-2.186,13.014 c-1.615-0.025-4.439-0.076-6.055-0.149c-0.593-0.03-1.179-0.058-1.767-0.096c-0.525-0.025-1.06-0.061-1.588-0.098 c-0.24-0.013-0.48-0.028-0.719-0.045c-0.449-0.033-0.891-0.066-1.34-0.101c-9.877-0.798-19.746-2.527-29.617-5.2 c-0.05-3.89-0.101-11.808-0.114-22.028c0-0.56-0.002-1.128,0-1.704c-0.013-11.27,0.03-25.099,0.164-39.343 c0.013-1.126,0.025-2.254,0.038-3.385c0.013-1.525,0.03-3.059,0.051-4.599c0.005-0.31,0.008-0.618,0.013-0.929 c0.005-0.618,0.013-1.239,0.025-1.858c0.013-0.901,0.025-1.8,0.038-2.696c0.03-2.042,0.058-4.081,0.093-6.108 c0.475-28.274,1.429-54.262,3.249-60.875c0.169-0.608,0.346-1.055,0.525-1.32c0.194-0.293,0.434-0.593,0.702-0.898 c0.338-0.386,0.732-0.783,1.174-1.186c3.026-2.787,8.281-6.022,13.607-9.097c0.618-0.356,1.244-0.714,1.863-1.068 c0.093-0.051,14.473-4.902,14.566-4.957l15.041,1.053c1.807,1.063,16.038,5.899,17.782,6.987 c0.517,0.323,1.027,0.646,1.527,0.967c4.094,2.64,7.57,5.258,9.089,7.486c2.188,3.221,3.513,32.089,4.278,63.495 c0.02,0.722,0.038,1.446,0.056,2.168c0.078,3.322,0.151,6.664,0.217,10c0.068,3.297,0.126,6.588,0.182,9.852 c0.088,5.343,0.164,10.606,0.227,15.672c0.008,0.576,0.013,1.146,0.02,1.719c0.061,4.94,0.106,9.677,0.144,14.099 c0.005,0.58,0.008,1.151,0.013,1.719c0.05,6.643,0.081,12.519,0.083,17.239v0.005 C289.192,381.95,289.192,382.581,289.192,383.194z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#EDEDED"
    },
    points: "248.562,251.48 257.313,325.331 247.843,343.609 238.123,325.331 247.395,251.502  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFFFFF"
    },
    points: "253.987,248.54 247.903,258.303 241.627,248.626 247.807,236.82  "
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#015288"
    },
    d: "M239.168,227.647c0,0-5.41-0.058-7.243,4.306c0,0-0.554,13.383,9.703,16.673l6.18-11.806 C247.807,236.82,240.106,234.444,239.168,227.647z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#015288"
    },
    d: "M255.884,227.647c0,0,4.638,0.678,6.471,5.043c0,0,1.878,12.646-8.38,15.936l-6.168-11.806 C247.807,236.82,254.945,234.444,255.884,227.647z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#015288"
    },
    d: "M249.993,351.221c0,1.207-0.979,2.186-2.186,2.186c-1.207,0-2.186-0.979-2.186-2.186 c0-1.207,0.979-2.186,2.186-2.186C249.014,349.035,249.993,350.013,249.993,351.221z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#015288"
    },
    d: "M249.993,368.641c0,1.207-0.979,2.186-2.186,2.186c-1.207,0-2.186-0.979-2.186-2.186 c0-1.207,0.979-2.186,2.186-2.186C249.014,366.456,249.993,367.434,249.993,368.641z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#015288"
    },
    d: "M268.241,292.616h-0.894c-4.857,0-8.795-3.937-8.795-8.794v-11.296h18.484v11.296 C277.036,288.678,273.098,292.616,268.241,292.616z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#01305A"
    },
    d: "M227.103,190.48c0,0,0.339-8.016-0.741-11.207c-1.911-5.644-0.992-9.98,3.231-11.33 c4.834-1.545,0.859-4.908,5.522-6.381s5.796,2.498,8.624,0.982c2.829-1.516,3.788-2.609,6.591-2.986 c4.26-0.573,4.529,3.486,7.468,2.945c4.884-0.9,7.614,2.25,8.606,5.44c0.992,3.19,0.236,4.095,2.493,5.031 c3.356,1.391,2.742,6.912,0.901,9.244c-1.84,2.331-1.538,3.255-1.669,6.945C267.999,192.852,227.103,190.48,227.103,190.48z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FB9E82"
    },
    d: "M266.043,197.639c0,0,3.53-4.706,6.154-0.814c2.625,3.891-1.086,15.385-7.512,12.58 L266.043,197.639z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FC7972"
    },
    d: "M266.089,205.852c0.237,0,0.455-0.157,0.523-0.396c0.996-3.549,4.672-4.987,4.709-5.001 c0.28-0.107,0.421-0.42,0.314-0.7c-0.106-0.28-0.419-0.421-0.699-0.316c-0.172,0.065-4.223,1.637-5.37,5.724 c-0.081,0.289,0.088,0.588,0.376,0.669C265.991,205.845,266.04,205.852,266.089,205.852z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FC7972"
    },
    d: "M269.799,204.065c0.101,0,0.203-0.028,0.294-0.087c0.252-0.163,0.325-0.498,0.162-0.751 c-0.027-0.042-0.677-1.034-2.038-1.643c-0.272-0.123-0.595,0-0.717,0.274c-0.122,0.274,0,0.595,0.274,0.717 c1.052,0.471,1.563,1.232,1.568,1.24C269.446,203.977,269.621,204.065,269.799,204.065z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FB9E82"
    },
    d: "M229.669,197.639c0,0-3.529-4.706-6.154-0.814c-2.625,3.891,1.086,15.385,7.512,12.58 L229.669,197.639z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FC7972"
    },
    d: "M229.623,205.852c-0.237,0-0.455-0.157-0.523-0.396c-0.996-3.549-4.672-4.987-4.709-5.001 c-0.28-0.107-0.421-0.42-0.315-0.7c0.106-0.28,0.42-0.421,0.699-0.316c0.172,0.065,4.223,1.637,5.37,5.724 c0.081,0.289-0.087,0.588-0.376,0.669C229.721,205.845,229.672,205.852,229.623,205.852z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FC7972"
    },
    d: "M225.912,204.065c-0.101,0-0.202-0.028-0.294-0.087c-0.252-0.163-0.325-0.498-0.162-0.751 c0.027-0.042,0.677-1.034,2.038-1.643c0.273-0.123,0.595,0,0.717,0.274c0.123,0.274,0,0.595-0.274,0.717 c-1.052,0.471-1.564,1.232-1.568,1.24C226.266,203.977,226.091,204.065,225.912,204.065z"
  }))))), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FDBEAB"
    },
    d: "M239.168,219.153v11.43c0,0,3.409,5.821,8.019,6.218c4.605,0.402,8.698-5.012,8.698-5.012v-11.832 L239.168,219.153z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FB9E82"
    },
    d: "M239.168,219.153v5.072c3.093,3.432,8.587,4.29,16.716,3.09v-7.358L239.168,219.153z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FDBEAB"
    },
    d: "M227.119,189.8c0.209,4.442,0.632,9.998,1.481,14.436v0.013c0,0.013,0.004,0.026,0.009,0.043 c0,0.004,0.004,0.004,0.004,0.009c0.209,1.084,0.444,2.104,0.7,3.021c0.154,0.538,0.32,1.101,0.508,1.677 c2.71,8.5,8.986,20.802,24.762,15.174c6.644-2.368,10.105-9.23,11.867-16.672c0.102-0.444,0.201-0.883,0.286-1.306 c0.06-0.282,0.115-0.555,0.166-0.824l0.077-0.397c0.013-0.068,0.021-0.115,0.026-0.145c0.004-0.017,0.004-0.026,0.004-0.026 c1.041-5.722,1.199-11.508,1.122-15.643c-0.081-4.216-2.385-8.073-6.055-10.151c-9.938-5.637-20.431-3.533-27.339-0.879 C229.939,179.968,226.871,184.675,227.119,189.8z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#01305A"
    },
    d: "M228.595,204.235c0,0,0,0.004,0.004,0.013c0,0.013,0.004,0.026,0.009,0.043 c0,0.004,0.004,0.004,0.004,0.009c0.102,0.371,0.657,2.406,1.208,4.698c2.71,8.5,8.986,20.802,24.762,15.174 c6.644-2.368,10.105-9.23,11.867-16.672c0.102-0.444,0.201-0.883,0.286-1.306c0.06-0.282,0.115-0.555,0.166-0.824l0.077-0.397 c0.013-0.068,0.021-0.115,0.026-0.145c0.004-0.017,0.004-0.026,0.004-0.026l-2.321-0.469c-0.444,2.198-1.425,4.267-2.629,6.106 c-1.963-4.702-11.922-1.579-11.922-1.579l-0.047,0.017c-0.606,0.188-1.229,0.286-1.856,0.286c-0.644,0-1.284-0.102-1.907-0.303 c0,0-9.84-3.26-11.88,1.225c-2.04-3.158-3.422-6.021-3.422-6.021l-2.424,0.171H228.595z M248.207,210.99 c11.261-1.519,9.49,4.544,9.49,4.544c-1.25,1.139-2.394,1.971-3.162,2.402c-2.458,1.37-4.877,1.89-6.631,1.805 c-1.728-0.073-2.202,0.282-6.571-2.082c-0.772-0.414-1.553-1.028-2.317-1.758c0,0,0,0-0.004,0v-0.004 C238.823,214.711,236.916,209.048,248.207,210.99z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#01305A"
    },
    d: "M238.002,198.065c0,1.22,0.629,2.209,1.405,2.209c0.775,0,1.404-0.989,1.404-2.209 c0-1.22-0.629-2.209-1.404-2.209C238.631,195.856,238.002,196.845,238.002,198.065z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#01305A"
    },
    d: "M255.561,198.065c0,1.22,0.629,2.209,1.404,2.209c0.776,0,1.405-0.989,1.405-2.209 c0-1.22-0.629-2.209-1.405-2.209C256.189,195.856,255.561,196.845,255.561,198.065z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#01305A"
    },
    d: "M234.406,190.616c0,0,5.804-2.294,10.273-0.363l-0.447,2.485c0,0-6.559-0.555-9.864,0.784 C234.073,192.566,234.029,191.599,234.406,190.616z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#01305A"
    },
    d: "M262.003,190.627c0,0-5.847-2.311-10.348-0.366l0.45,2.504c0,0,6.607-0.559,9.936,0.79 C262.339,192.592,262.383,191.618,262.003,190.627z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FB9E82"
    },
    d: "M247.667,207.939c-0.916,0-1.825-0.356-1.965-0.414c-0.277-0.113-0.41-0.43-0.297-0.708 c0.113-0.278,0.43-0.411,0.707-0.298c0.491,0.199,1.668,0.511,2.178,0.206c0.098-0.059,0.233-0.176,0.267-0.506 c0.196-1.896-0.323-8.252-0.328-8.316c-0.025-0.299,0.198-0.561,0.497-0.586c0.3-0.025,0.561,0.198,0.586,0.497 c0.022,0.265,0.533,6.521,0.326,8.517c-0.078,0.751-0.472,1.136-0.79,1.326C248.501,207.866,248.083,207.939,247.667,207.939z "
  })))), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M254.59,212.075c-0.412,2.074-1.783,5.89-6.398,5.89c-4.627,0-5.925-3.487-6.37-5.89H254.59z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#01305A"
    },
    d: "M227.117,189.798c0.212,4.442,0.635,9.997,1.483,14.438l2.427-0.172c0,0-0.588-3.751-0.86-6.194 c-0.271-2.444-0.733-7.011,1.353-7.581c2.079-0.565,0.859-5.775,3.753-8.034c2.894-2.264,9.368-2.885,13.636-0.257 c4.268,2.623,9.078-0.199,11.044,0.257c1.971,0.451,4.643,3.166,3.921,5.702c-0.728,2.53,1.444,4.073,1.971,6.695 c0.527,2.623-1.157,9.682-1.157,9.682l2.319,0.467c1.043-5.723,1.2-11.507,1.124-15.639c-0.081-4.219-2.384-8.075-6.055-10.154 c-9.943-5.636-20.433-3.535-27.34-0.88C229.94,179.969,226.872,184.677,227.117,189.798z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3B73A9"
    },
    d: "M211.725,242.889c0,0-14.28,9.531-23.459,12.365l6.147,25.758c0,0,0.848-0.352,11.264-4.778 L211.725,242.889z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3B73A9"
    },
    d: "M281.748,242.889c0,0,27.298,13.992,36.477,16.826c-3.511,6.332-5.752,12.219-8.741,20.707 c0,0-13.115-3.47-23.532-7.896L281.748,242.889z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#375BC7"
    },
    d: "M392.667,414.68c-0.505-9.557-0.902-15.8-0.902-15.8l-28.018,1.245l-2.323,0.105l-4.121,0.184 c0,0,0.313,5.65,0.815,14.266H392.667z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#01305A"
    },
    d: "M392.667,414.68c-0.505-9.557-0.902-15.8-0.902-15.8l-28.018,1.245l-2.323,0.105l-4.121,0.184 c0,0,0.313,5.65,0.815,14.266H392.667z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#001336"
    },
    d: "M364.555,414.68c-0.346-6.124-0.626-11.206-0.809-14.554l-2.323,0.105 c0.182,3.325,0.461,8.368,0.804,14.449H364.555z"
  }))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#01305A"
    },
    d: "M349.299,414.68c0.506-8.617,0.817-14.266,0.817-14.266l-4.472-0.199l-2.32-0.105l-27.674-1.23 c0,0-0.304,4.787-0.72,12.397c-0.059,1.078-0.12,2.217-0.182,3.403H349.299z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#001336"
    },
    d: "M344.839,414.68c0.344-6.09,0.622-11.139,0.803-14.465l-2.32-0.105 c-0.183,3.348-0.464,8.436-0.81,14.569H344.839z"
  }))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#01305A"
    },
    d: "M331.814,194.94c0,12.628,7.774,21.329,20.397,21.329c12.628,0,21.431-9.355,21.431-21.983 c0-3.483-0.568-6.735-1.661-9.612c-0.064-0.171-0.129-0.343-0.198-0.509c-0.134-0.327-0.273-0.654-0.423-0.97 c-0.22-0.488-0.466-0.964-0.723-1.425c-3.29-5.915-9.183-9.676-17.102-9.676C338.394,172.094,331.814,182.311,331.814,194.94z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#01305A"
    },
    d: "M339.492,175.461c0,7.313,5.928,13.242,13.242,13.242c7.313,0,13.241-5.928,13.241-13.242 c0-7.313-5.928-13.242-13.241-13.242C345.421,162.219,339.492,168.148,339.492,175.461z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FB9E82"
    },
    d: "M334.649,200.377c0,0-3.508-4.678-6.117-0.81c-2.609,3.868,1.079,15.292,7.466,12.504 L334.649,200.377z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FC7972"
    },
    d: "M334.604,208.54c-0.236,0-0.452-0.156-0.52-0.394c-0.99-3.527-4.644-4.957-4.681-4.971 c-0.278-0.106-0.418-0.418-0.313-0.696c0.105-0.278,0.417-0.419,0.695-0.313c0.171,0.065,4.197,1.627,5.338,5.689 c0.08,0.287-0.087,0.585-0.374,0.665C334.702,208.533,334.652,208.54,334.604,208.54z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FC7972"
    },
    d: "M330.916,206.763c-0.1,0-0.201-0.028-0.292-0.086c-0.25-0.161-0.323-0.495-0.162-0.746 c0.027-0.041,0.673-1.028,2.026-1.633c0.271-0.122,0.591,0,0.713,0.272c0.122,0.272,0,0.591-0.272,0.713 c-1.046,0.468-1.554,1.225-1.559,1.233C331.267,206.676,331.093,206.763,330.916,206.763z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FB9E82"
    },
    d: "M370.803,200.377c0,0,3.508-4.678,6.117-0.81c2.609,3.868-1.08,15.292-7.466,12.504 L370.803,200.377z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FC7972"
    },
    d: "M370.849,208.54c0.236,0,0.452-0.156,0.519-0.394c0.99-3.527,4.644-4.957,4.681-4.971 c0.278-0.106,0.418-0.418,0.312-0.696c-0.105-0.278-0.417-0.419-0.695-0.313c-0.171,0.065-4.197,1.627-5.338,5.689 c-0.08,0.287,0.087,0.585,0.374,0.665C370.751,208.533,370.801,208.54,370.849,208.54z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FC7972"
    },
    d: "M374.537,206.763c0.1,0,0.202-0.028,0.292-0.086c0.251-0.161,0.323-0.495,0.162-0.746 c-0.027-0.041-0.673-1.028-2.026-1.633c-0.271-0.122-0.591,0-0.713,0.272c-0.122,0.272,0,0.591,0.272,0.713 c1.046,0.468,1.554,1.225,1.559,1.233C374.186,206.676,374.36,206.763,374.537,206.763z"
  }))))), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FDBEAB"
    },
    d: "M361.362,221.76v11.361c0,0-3.388,5.786-7.97,6.18c-4.577,0.399-8.645-4.982-8.645-4.982v-11.76 L361.362,221.76z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FB9E82"
    },
    d: "M361.362,221.76v5.041c-3.074,3.412-8.535,4.264-16.615,3.071v-7.313L361.362,221.76z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FDBEAB"
    },
    d: "M332.575,195.476c0.004,0.206,0.009,0.417,0.013,0.633c0.014,0.552,0.032,1.113,0.058,1.692 c0.013,0.292,0.027,0.584,0.045,0.875c0.018,0.296,0.031,0.592,0.054,0.893c0,0.013,0,0.049,0.005,0.099 c0.018,0.265,0.04,0.53,0.058,0.804c0.171,2.222,0.44,4.552,0.857,6.872c0.009,0.049,0.018,0.103,0.027,0.153 c0.067,0.377,0.144,0.754,0.22,1.131c1.625,7.976,5.068,15.603,12.128,18.121c16.743,5.979,22.722-8.376,25.114-16.747 c0.216-0.759,0.418-1.594,0.592-2.473c0.041-0.193,0.081-0.391,0.117-0.592c0.009-0.049,0.018-0.099,0.027-0.153 c0.817-4.349,1.235-9.732,1.445-14.072c0-0.045,0.004-0.085,0.004-0.126c0.243-5.09-2.81-9.772-7.572-11.599 c-6.868-2.639-17.295-4.731-27.174,0.871c-3.649,2.069-5.939,5.903-6.019,10.095 C332.557,193.025,332.553,194.21,332.575,195.476z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#01305A"
    },
    d: "M333.666,207.344c0.009,0.049,0.018,0.103,0.027,0.153c1.526,8.376,4.955,16.612,12.348,19.252 c16.743,5.979,22.722-8.376,25.114-16.747c0.265-0.929,0.503-1.966,0.709-3.066c0.009-0.049,0.018-0.099,0.027-0.153l-1.8-0.126 c0,0-1.414,2.927-3.497,6.149c-2.083-4.578-12.137-1.248-12.137-1.248c-0.633,0.202-1.288,0.305-1.948,0.305 c-0.637,0-1.275-0.099-1.894-0.292l-0.049-0.013c0,0-10.171-3.191-12.178,1.611c-1.23-1.881-2.231-3.995-2.684-6.239 L333.666,207.344z M352.536,213.731c11.536-1.984,9.588,3.802,9.395,5.014v0.004c-0.004,0-0.004,0-0.004,0 c-0.781,0.745-1.58,1.374-2.366,1.795c-4.466,2.415-4.951,2.051-6.715,2.128c-1.791,0.085-4.264-0.444-6.773-1.845 c-0.785-0.44-1.953-1.288-3.232-2.455C342.841,218.372,341.032,212.178,352.536,213.731z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#01305A"
    },
    d: "M345.548,201.859c0,1.213-0.625,2.196-1.396,2.196c-0.771,0-1.396-0.983-1.396-2.196 c0-1.213,0.625-2.196,1.396-2.196C344.923,199.663,345.548,200.647,345.548,201.859z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#01305A"
    },
    d: "M362.002,201.814c0,1.213-0.625,2.196-1.396,2.196c-0.771,0-1.396-0.983-1.396-2.196 c0-1.213,0.625-2.196,1.396-2.196C361.378,199.618,362.002,200.602,362.002,201.814z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#01305A"
    },
    d: "M365.157,194.268c0,0-4.405-1.741-7.796-0.276l0.339,1.886c0,0,4.978-0.421,7.486,0.596 C365.411,195.748,365.444,195.014,365.157,194.268z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#01305A"
    },
    d: "M339.493,194.268c0,0,4.405-1.741,7.796-0.276l-0.339,1.886c0,0-4.978-0.421-7.486,0.596 C339.24,195.748,339.207,195.014,339.493,194.268z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FB9E82"
    },
    d: "M353.395,211.062c0.91,0,1.813-0.354,1.954-0.411c0.276-0.113,0.408-0.427,0.295-0.703 c-0.112-0.276-0.428-0.408-0.703-0.296c-0.488,0.198-1.658,0.508-2.165,0.205c-0.098-0.059-0.231-0.175-0.265-0.503 c-0.195-1.885,0.321-8.202,0.326-8.266c0.024-0.297-0.196-0.558-0.494-0.582c-0.298-0.025-0.557,0.197-0.582,0.494 c-0.022,0.264-0.529,6.482-0.324,8.465c0.077,0.747,0.469,1.129,0.785,1.318C352.567,210.989,352.982,211.062,353.395,211.062z "
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M345.667,215.185c0.897,3.114,3.448,6.221,6.961,6.263c3.51-0.042,6.06-3.15,6.958-6.263H345.667 z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#01305A"
    },
    d: "M332.575,195.476c0.004,0.206,0.009,0.417,0.013,0.633c0.014,0.552,0.036,1.118,0.058,1.692 c0.013,0.292,0.027,0.584,0.045,0.875c0.018,0.296,0.031,0.592,0.054,0.893c0,0.013,0,0.049,0.005,0.099 c0.018,0.265,0.04,0.53,0.058,0.804c0.171,2.222,0.44,4.552,0.857,6.872c0.009,0.049,0.018,0.103,0.027,0.153 c0.067,0.377,0.144,0.754,0.22,1.131l1.858-1.387c-0.117-1.203-1.073-9.085-0.924-9.83c0.525-2.608,3.649-5.395,2.927-7.909 c-0.718-2.523-1.791-5.772,0.166-6.221c1.953-0.453,10.005-0.525,15.019-0.364c4.978,0.162,12.137-0.804,15.014,1.45 c2.877,2.244-5.382,6.746,0.992,8.704c2.015,0.619,1.32,11.132,1.05,13.587l1.733,0.871c0.041-0.193,0.081-0.391,0.117-0.592 c0.009-0.049,0.018-0.099,0.027-0.153c0.817-4.349,1.235-9.732,1.445-14.072c0-0.045,0.004-0.085,0.004-0.126 c0.243-5.09-2.81-9.772-7.572-11.599c-6.868-2.639-17.295-4.731-27.174,0.871c-3.649,2.069-5.939,5.903-6.019,10.095 C332.557,193.025,332.553,194.21,332.575,195.476z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FD7C78"
    },
    d: "M361.696,233.359c1.409,0.992,3.224,2.154,5.84,3.568c1.333,0.723,2.779,1.49,4.287,2.289 c2.33,1.225,4.807,2.527,7.263,3.856l0.004,0.004c3.641,1.966,7.222,3.999,10.198,5.934c2.971,1.944,5.332,3.798,6.5,5.404 c1.683,2.325,2.774,17.371,3.474,37.175c0.027,0.691,0.049,1.396,0.076,2.105c0.004,0.085,0.004,0.166,0.004,0.256 c0.027,0.723,0.049,1.459,0.072,2.2c0.067,2.226,0.135,4.502,0.197,6.818c0.018,0.489,0.027,0.979,0.036,1.472 c0.013,0.368,0.022,0.736,0.027,1.104c0.072,2.837,0.135,5.727,0.193,8.65c0.04,2.002,0.081,4.017,0.112,6.042 c0.615,35.308,0.467,73.601,0.323,84.014c-7.631,1.93-15.266,3.384-22.897,4.368h-0.004c-1.989,0.256-3.982,0.48-5.965,0.673 c-0.664,0.063-1.329,0.121-1.989,0.175c-3.577,0.305-7.155,0.512-10.732,0.615c-5.911,0.166-11.823,0.045-17.739-0.355 c-4.062-0.274-8.129-0.682-12.191-1.225c-7.37-0.983-14.741-2.402-22.116-4.251c-0.135-12.42,0.157-65.512,1.643-105.223 c0.027-0.637,0.05-1.266,0.072-1.894c0.889-22.874,2.181-40.914,4.035-43.459c2.235-3.061,8.295-6.841,14.705-10.445 c2.608-1.468,5.274-2.904,7.766-4.251c4.112-2.222,7.752-4.21,9.853-5.682l0,0c0,0,4.071,6.405,8.65,6.006 c4.17-0.359,7.417-5.3,7.969-6.18L361.696,233.359z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#D64E5A"
    },
    d: "M377.809,379.506c-0.001,0-0.002,0-0.003,0c-15.374-0.068-28.498-7.064-36.799-12.921 c-8.978-6.335-14.419-12.753-14.473-12.817c-0.263-0.312-0.223-0.779,0.09-1.042c0.313-0.263,0.78-0.223,1.042,0.089 c0.053,0.063,5.395,6.359,14.228,12.585c8.121,5.724,20.945,12.561,35.919,12.626c0.409,0.002,0.738,0.335,0.737,0.743 C378.547,379.177,378.216,379.506,377.809,379.506z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#D64E5A"
    },
    d: "M361.786,384.73c-13.341,0-26.645-7.602-27.25-7.953c-0.353-0.205-0.474-0.657-0.27-1.011 c0.204-0.354,0.657-0.474,1.01-0.27c0.156,0.09,15.811,9.03,29.691,7.594c0.412-0.047,0.77,0.254,0.812,0.66 c0.042,0.406-0.253,0.77-0.66,0.812C364.013,384.677,362.899,384.73,361.786,384.73z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#D64E5A"
    },
    d: "M341.672,258.624c-0.349,0-0.659-0.247-0.726-0.602c-0.076-0.401,0.187-0.789,0.589-0.865 c18.745-3.557,24.394-15.615,24.449-15.737c0.168-0.372,0.606-0.538,0.979-0.369c0.372,0.168,0.537,0.606,0.369,0.979 c-0.237,0.524-6.028,12.882-25.521,16.581C341.764,258.62,341.717,258.624,341.672,258.624z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#D64E5A"
    },
    d: "M379.143,296.903h-0.894c-4.857,0-8.795-3.937-8.795-8.794v-11.296h18.483v11.296 C387.938,292.966,384,296.903,379.143,296.903z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FDBEAB"
    },
    d: "M282.698,414.68c-0.007-0.04-0.011-0.078-0.018-0.118c-1.425-8.403,2.623-16.012,4.369-15.769 c1.75,0.247-1.446,9.177,0.109,12.395c1.55,3.218,3.557-3.036,5.555-6.827c2.072-3.939,1.95-12.534,1.008-18.666 c-0.942-6.136,10.176-43.395,10.232-54.191l1.355-4.578l4.96-16.759l7.765-26.245c0,0-4.651-19.865-12.495-18.158 c0,0-4.152,13.837-8.59,29.441c-0.751,2.649-1.511,5.35-2.263,8.043c-3.162,11.314-6.132,22.484-7.513,29.111 c-3.648,17.498-3.93,53.87-3.93,53.87s-6.436,13.363-6.588,19.309c-0.086,3.4,0.831,6.427,1.641,9.143H282.698z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FB9E82"
    },
    d: "M294.684,303.246l10.623,23.678l4.96-16.759l-13.32-14.961 C296.196,297.853,295.436,300.554,294.684,303.246z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FD7C78"
    },
    d: "M294.158,296.194c4.66,7.991,9.398,15.939,14.119,23.9c1.555-5.207,3.166-10.206,4.677-14.801 c0.004-0.013,0.009-0.022,0.013-0.035c0.604-1.837,1.194-3.609,1.759-5.303c0.009-0.031,0.018-0.061,0.031-0.087 c0.195-0.595,0.386-1.181,0.582-1.755v-0.004c2.254-6.814,4-12.23,4.499-15.387c1.346-8.499-1.805-23.579-6.481-27.866 l-0.532-0.405c-0.302-0.18-0.418-0.45-0.757-0.101c-1.594,1.638-5.446,7.157-7.44,12.204c-0.256,0.643-0.516,1.312-0.786,1.993 C300.955,275.968,297.424,285.623,294.158,296.194z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#D64E5A"
    },
    d: "M307.567,324.79c1.537-6.354,3.47-13.415,5.385-19.5c0.004-0.013,0.009-0.022,0.013-0.035 c0.591-1.88,1.181-3.665,1.759-5.303c0.009-0.03,0.017-0.061,0.03-0.087c0.178-0.517,0.361-1.016,0.538-1.503 c0.026-0.087,0.043-0.169,0.043-0.252v-0.004c0-0.291-0.182-0.564-0.473-0.673c-0.378-0.135-0.795,0.056-0.93,0.434 c-1.963,5.351-4.282,13.055-6.271,20.612C307.628,320.573,307.597,322.68,307.567,324.79z"
  }))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#D64E5A"
    },
    d: "M393.351,298.109v0.004c0,0.081,0.018,0.162,0.045,0.251c0.18,0.485,0.359,0.983,0.538,1.499 c0.014,0.027,0.023,0.058,0.032,0.09c0.579,1.638,1.167,3.42,1.759,5.301c0.004,0.014,0.009,0.023,0.013,0.036 c1.463,4.659,2.944,9.897,4.242,14.947c-0.031-2.024-0.072-4.04-0.112-6.042c-1.692-6.1-3.523-11.989-5.112-16.33 c-0.135-0.377-0.552-0.565-0.929-0.431C393.535,297.543,393.351,297.817,393.351,298.109z"
  }))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FDBEAB"
    },
    d: "M428.372,314.692L428.372,314.692c-4.109-8.772-32.315-59.788-32.315-59.788 c-5.32,3.167,3.684,53.351,3.684,53.351l11.19,28.567c2.564,6.745,10.552,9.584,16.805,5.982 c0.106-0.061,0.214-0.124,0.322-0.188C438.845,336.209,428.372,314.692,428.372,314.692z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FD7C78"
    },
    d: "M396.056,254.904l26.061,37.262c0,0-10.36,22.587-22.255,21.729 C399.863,313.895,385.197,262.545,396.056,254.904z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#01305A"
    },
    points: "429.026,291.279 428.699,295.046 428.141,301.397 428.033,302.615 427.565,308.018  427.046,313.895 427.024,314.172 426.437,320.906 425.918,326.907 425.27,334.352 404.576,334.352 404.424,332.648  403.798,325.407 403.415,321.041 402.794,313.895 402.783,313.777 402.399,309.423 401.813,302.615 401.768,302.125  401.39,297.793 400.82,291.279  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFFFFF"
    },
    points: "428.033,302.615 427.565,308.018 427.046,313.895 402.794,313.895 402.783,313.777  402.399,309.423 401.813,302.615  "
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 399.373,
    y: 285.771,
    style: {
      fill: "#015288"
    },
    width: 31.101,
    height: 5.507
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#01305A"
    },
    d: "M428.13,285.771h-26.414v-3.199c0-0.816,0.662-1.478,1.478-1.478h23.458 c0.816,0,1.478,0.662,1.478,1.478V285.771z"
  }))), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FDBEAB"
    },
    d: "M429.732,295.221c0,0-3.921,0.263-9.54,1.577c-2.854,0.667-9.055,4.406-6.409,5.781 c2.09,1.085,11.479-1.541,13.336-0.688c0,0-4.44,0.91-8.222,1.493c-3.42,0.528-8.703,2.522-6.647,3.613 c1.943,1.031,6.814,0.609,8.549,0.655c2.304,0.06,5.22,0.02,5.22,0.02s-3.677,0.612-8.01,1.92 c-1.982,0.599-7.703,1.176-5.885,3.76c0.912,1.297,8.635,0.361,12.514,0.708c0,0-7.145,1.21-9.217,3.153 c-1.639,1.536,0.593,1.744,3.477,1.95c3.72,0.266,4.861,0,7.12,0c2.259,0,6.059-1.6,6.139-3.918 c0.081-2.317-1.213-3.287-0.809-4.743c0.405-1.456,1.344-3.682,0.812-4.96c-0.532-1.277-0.372-2.35,0.159-4.015 C432.842,299.894,431.914,295.896,429.732,295.221z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M355.039,202.666c0-3.71,3.018-6.728,6.728-6.728c3.71,0,6.728,3.018,6.728,6.728 c0,3.71-3.018,6.728-6.728,6.728C358.058,209.394,355.039,206.376,355.039,202.666z M356.088,202.666 c0,3.132,2.547,5.68,5.679,5.68c3.132,0,5.679-2.548,5.679-5.68s-2.548-5.679-5.679-5.679 C358.635,196.986,356.088,199.534,356.088,202.666z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M336.649,202.666c0-3.71,3.018-6.728,6.728-6.728c3.71,0,6.728,3.018,6.728,6.728 c0,3.71-3.018,6.728-6.728,6.728C339.667,209.394,336.649,206.376,336.649,202.666z M337.698,202.666 c0,3.132,2.548,5.68,5.679,5.68c3.132,0,5.679-2.548,5.679-5.68s-2.548-5.679-5.679-5.679 C340.245,196.986,337.698,199.534,337.698,202.666z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M373.805,197.58c0-0.289-0.233-0.527-0.521-0.529c-3.65-0.033-6.174,2.431-6.296,2.551 c-0.205,0.204-0.206,0.536-0.002,0.742c0.102,0.103,0.237,0.154,0.372,0.154c0.133,0,0.267-0.051,0.369-0.152 c0.026-0.026,2.323-2.253,5.544-2.24C373.565,198.107,373.805,197.874,373.805,197.58L373.805,197.58z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M337.949,199.535c-0.151-0.099-2.891-1.866-5.966-2.446c-0.323-0.061-0.623,0.189-0.623,0.518 l0,0c0,0.25,0.175,0.467,0.42,0.514c2.886,0.547,5.56,2.269,5.595,2.292c0.088,0.058,0.188,0.085,0.286,0.085 c0.171,0,0.339-0.084,0.44-0.238C338.26,200.019,338.192,199.694,337.949,199.535z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M349.735,201.154c0.012-0.016,1.258-1.701,2.896-1.701c1.622,0,2.748,1.682,2.759,1.699 l0.878-0.574c-0.058-0.089-1.442-2.174-3.637-2.174c-2.18,0-3.684,2.049-3.747,2.137L349.735,201.154z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FDBEAB"
    },
    d: "M176.396,274.919l13.318,48.425l0.262,0.884c0,0.219,0.008,0.446,0.016,0.688 c0.485,11.738,11.277,48.098,10.342,54.182c-0.954,6.213-1.075,14.913,1.02,18.901c2.022,3.84,4.055,10.17,5.627,6.913 c1.572-3.261-1.662-12.301,0.106-12.548c1.771-0.25,5.869,7.457,4.422,15.965c-1.443,8.508,3.671,10.788,3.284,6.589 c-0.383-4.203,2.987-9.31,2.823-15.726c-0.156-6.022-6.671-19.551-6.671-19.551s-0.285-36.829-3.976-54.545 c-3.695-17.716-18.37-73.36-18.37-73.36C180.308,260.525,176.396,274.919,176.396,274.919z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FB9E82"
    },
    d: "M189.722,323.372l0.254,0.855c0,0.212,0.007,0.431,0.015,0.666 c2.575-0.885,5.048-1.634,6.871-1.978c0.408-0.076,0.685-0.473,0.605-0.885c-0.076-0.42-0.473-0.692-0.885-0.605 C194.729,321.776,192.275,322.502,189.722,323.372z"
  })))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#01305A"
    },
    d: "M193.593,414.479c-0.512-3.292-1.012-6.603-1.497-9.882c-0.322-2.197-0.636-4.375-0.947-6.525 c-1.176-8.226-2.227-16.004-3.07-22.458c-0.322-2.452-0.61-4.716-0.873-6.735c-0.817-6.443-1.298-10.445-1.298-10.445 l-36.192,1.368l-36.303-1.368c0,0-0.936,7.919-2.434,19.4c-0.274,2.09-0.566,4.294-0.873,6.595 c-0.806,6.025-1.727,12.679-2.718,19.492c-0.015,0.1-0.03,0.2-0.045,0.3c-0.311,2.123-0.625,4.261-0.951,6.399 c-0.004,0.029-0.007,0.055-0.015,0.085v0.004c-0.189,1.259-0.381,2.517-0.574,3.772H193.593z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#001336"
    },
    d: "M121.756,369.304c0,1.884-1.527,3.411-3.411,3.411c-1.884,0-3.411-1.527-3.411-3.411 c0-1.884,1.527-3.411,3.411-3.411C120.229,365.893,121.756,367.42,121.756,369.304z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#001336"
    },
    d: "M130.221,382.519c0,1.884-1.527,3.411-3.411,3.411c-1.884,0-3.411-1.527-3.411-3.411 c0-1.884,1.527-3.411,3.411-3.411C128.693,379.108,130.221,380.635,130.221,382.519z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#001336"
    },
    d: "M146.874,375.697c0,1.884-1.527,3.411-3.411,3.411c-1.884,0-3.411-1.527-3.411-3.411 c0-1.884,1.527-3.411,3.411-3.411C145.347,372.286,146.874,373.813,146.874,375.697z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#001336"
    },
    d: "M120.59,396.553c0,1.884-1.527,3.411-3.411,3.411c-1.884,0-3.411-1.527-3.411-3.411 c0-1.884,1.527-3.411,3.411-3.411C119.062,393.142,120.59,394.669,120.59,396.553z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#001336"
    },
    d: "M141.4,395.095c0,1.884-1.527,3.411-3.411,3.411c-1.884,0-3.411-1.527-3.411-3.411 c0-1.884,1.527-3.411,3.411-3.411C139.873,391.683,141.4,393.211,141.4,395.095z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#001336"
    },
    d: "M113.199,381.033c0,1.775-1.354,3.236-3.092,3.396c0.307-2.301,0.599-4.505,0.873-6.595 C112.278,378.318,113.199,379.565,113.199,381.033z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#001336"
    },
    d: "M175.248,414.479c-0.306-1.57-1.687-2.755-3.347-2.755c-1.66,0-3.041,1.185-3.347,2.755 H175.248z"
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#001336"
    },
    cx: 170.29,
    cy: 396.553,
    r: 3.411
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#001336"
    },
    d: "M192.096,404.597c-0.411,0.174-0.865,0.27-1.339,0.27c-1.883,0-3.41-1.528-3.41-3.41 c0-1.883,1.528-3.41,3.41-3.41c0.133,0,0.262,0.007,0.392,0.026C191.46,400.222,191.774,402.4,192.096,404.597z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#001336"
    },
    d: "M109.345,407.327c0,1.731-1.291,3.162-2.966,3.377c0.007-0.03,0.011-0.056,0.015-0.085 c0.326-2.138,0.64-4.276,0.951-6.399C108.524,404.76,109.345,405.947,109.345,407.327z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#001336"
    },
    d: "M131.968,410.751c0,1.884-1.527,3.411-3.411,3.411c-1.884,0-3.411-1.527-3.411-3.411 c0-1.884,1.527-3.411,3.411-3.411C130.441,407.34,131.968,408.867,131.968,410.751z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#001336"
    },
    d: "M150.285,407.34c0,1.884-1.527,3.411-3.411,3.411c-1.884,0-3.411-1.527-3.411-3.411 c0-1.884,1.527-3.411,3.411-3.411C148.758,403.929,150.285,405.457,150.285,407.34z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#001336"
    },
    d: "M158.531,389.341c0,1.884-1.527,3.411-3.411,3.411c-1.884,0-3.411-1.527-3.411-3.411 c0-1.884,1.527-3.411,3.411-3.411C157.003,385.93,158.531,387.457,158.531,389.341z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#001336"
    },
    d: "M188.079,375.614c-0.237,0.056-0.481,0.082-0.732,0.082c-1.886,0-3.41-1.528-3.41-3.41 c0-1.835,1.45-3.336,3.27-3.406C187.469,370.898,187.758,373.162,188.079,375.614z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#001336"
    },
    d: "M170.29,375.697c0,1.884-1.527,3.411-3.411,3.411c-1.884,0-3.411-1.527-3.411-3.411 c0-1.884,1.527-3.411,3.411-3.411C168.762,372.286,170.29,373.813,170.29,375.697z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#001336"
    },
    d: "M182.783,387.853c0,1.884-1.527,3.411-3.411,3.411c-1.884,0-3.411-1.527-3.411-3.411 c0-1.884,1.527-3.411,3.411-3.411C181.256,384.442,182.783,385.969,182.783,387.853z"
  }))), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FD7C78"
    },
    d: "M187.523,359.329c-19.093,12.465-54.149,11.488-76.178,0c2.104-13.108,4.875-26.231,4.279-43.678 c-0.067-1.912-0.148-3.813-0.244-5.696c-0.085-1.638-0.181-3.266-0.285-4.875c-1.901-29.024-6.854-52.755-4.42-55.821 c1.062-1.343,2.833-2.792,5.019-4.276c0.858-0.584,1.775-1.176,2.744-1.768c2.286-1.394,4.827-2.8,7.379-4.168 c6.055-3.233,12.202-6.232,15.283-8.281c3.055,1.331,5.489,2.06,8.111,2.045c0.07,0,0.148,0,0.226-0.007 c0.07,0.007,0.148,0.007,0.218,0.007c2.622,0.015,5.056-0.714,8.115-2.045c2.859,1.901,8.241,4.553,13.733,7.445 c4.035,2.127,8.13,4.383,11.318,6.573c2.086,1.432,3.791,2.837,4.834,4.154c1.206,1.52,0.699,8.185-0.333,18.061 c-1.021,9.716-2.548,22.547-3.473,36.651c-0.255,3.917-0.466,7.93-0.607,12.002 C182.651,333.098,185.418,346.221,187.523,359.329z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#D64E5A"
    },
    d: "M174.121,345.67c-0.001,0-0.002,0-0.003,0c-15.374-0.067-28.498-7.064-36.799-12.921 c-8.978-6.335-14.419-12.753-14.473-12.817c-0.263-0.312-0.223-0.779,0.09-1.042c0.313-0.263,0.78-0.223,1.042,0.089 c0.053,0.063,5.395,6.359,14.228,12.585c8.121,5.724,20.945,12.561,35.919,12.626c0.409,0.002,0.738,0.335,0.736,0.743 C174.859,345.341,174.528,345.67,174.121,345.67z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#D64E5A"
    },
    d: "M158.099,350.894c-13.341,0-26.645-7.603-27.25-7.953c-0.354-0.205-0.474-0.657-0.27-1.011 c0.204-0.354,0.657-0.473,1.01-0.27c0.157,0.09,15.811,9.03,29.691,7.594c0.412-0.047,0.77,0.253,0.812,0.66 c0.042,0.406-0.253,0.77-0.66,0.812C160.326,350.841,159.212,350.894,158.099,350.894z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#D64E5A"
    },
    d: "M146.287,268.155c-0.349,0-0.659-0.247-0.726-0.602c-0.076-0.401,0.187-0.788,0.589-0.865 c18.745-3.557,24.394-15.615,24.449-15.737c0.168-0.372,0.606-0.538,0.979-0.369c0.372,0.168,0.537,0.606,0.369,0.979 c-0.237,0.524-6.028,12.882-25.521,16.581C146.379,268.151,146.332,268.155,146.287,268.155z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FDBEAB"
    },
    d: "M171.502,238.212c-3.721,8.486-12.461,19.997-24.355,17.942 c-11.518-1.991-17.387-10.806-21.33-17.107c6.056-3.234,12.203-6.23,15.283-8.28c3.056,1.33,5.49,2.058,8.11,2.046 c0.071,0,0.15,0,0.226-0.008c0.071,0.008,0.15,0.008,0.221,0.008c2.62,0.012,5.055-0.716,8.114-2.046 C160.629,232.666,166.012,235.318,171.502,238.212z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#01305A"
    },
    d: "M149.657,233.11v0.011c-0.072,0-0.149,0-0.221-0.006 C149.508,233.115,149.586,233.11,149.657,233.11z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#01305A"
    },
    d: "M168.677,171.763c0,0,8.999,13.939,8.013,28.459c-0.986,14.52,1.326,31.281-11.666,30.544 c-12.992-0.737-36.166,5.209-43.532-6.1C114.126,213.358,168.677,171.763,168.677,171.763z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FB9E82"
    },
    d: "M130.529,197.296c0,0-3.586-4.781-6.252-0.827c-2.667,3.954,1.103,15.631,7.632,12.781 L130.529,197.296z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FC7972"
    },
    d: "M130.483,205.641c-0.241,0-0.462-0.159-0.531-0.403c-1.012-3.605-4.747-5.067-4.784-5.081 c-0.284-0.108-0.428-0.427-0.319-0.711c0.108-0.284,0.426-0.428,0.71-0.321c0.175,0.066,4.291,1.663,5.456,5.815 c0.082,0.293-0.089,0.598-0.382,0.68C130.582,205.634,130.532,205.641,130.483,205.641z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FC7972"
    },
    d: "M126.713,203.825c-0.102,0-0.206-0.028-0.298-0.088c-0.256-0.165-0.33-0.507-0.165-0.763 c0.028-0.043,0.688-1.05,2.071-1.669c0.277-0.125,0.604,0,0.729,0.278c0.124,0.278,0,0.604-0.278,0.729 c-1.069,0.479-1.588,1.252-1.593,1.26C127.071,203.735,126.894,203.825,126.713,203.825z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FB9E82"
    },
    d: "M167.485,197.296c0,0,3.586-4.781,6.252-0.827c2.666,3.954-1.103,15.631-7.632,12.781 L167.485,197.296z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FC7972"
    },
    d: "M167.531,205.641c0.241,0,0.463-0.159,0.531-0.403c1.012-3.605,4.747-5.067,4.784-5.081 c0.284-0.108,0.427-0.427,0.32-0.711c-0.108-0.284-0.426-0.428-0.71-0.321c-0.174,0.066-4.291,1.663-5.456,5.815 c-0.082,0.293,0.089,0.598,0.382,0.68C167.432,205.634,167.482,205.641,167.531,205.641z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FC7972"
    },
    d: "M171.301,203.825c0.102,0,0.206-0.028,0.298-0.088c0.256-0.165,0.33-0.507,0.165-0.763 c-0.027-0.043-0.688-1.05-2.071-1.669c-0.277-0.125-0.604,0-0.729,0.278c-0.124,0.278,0,0.604,0.278,0.729 c1.069,0.479,1.589,1.252,1.593,1.26C170.942,203.735,171.12,203.825,171.301,203.825z"
  }))))), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FDBEAB"
    },
    d: "M157.834,219.154v11.613c0,0-3.463,5.914-8.147,6.317c-4.679,0.408-8.837-5.092-8.837-5.092 v-12.021L157.834,219.154z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FB9E82"
    },
    d: "M157.834,219.154v5.153c-3.143,3.487-8.723,4.723-16.982,3.504l-0.002-7.84L157.834,219.154z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FDBEAB"
    },
    d: "M170.078,189.33c-0.215,4.513-0.645,10.157-1.506,14.669c-0.215,1.125-0.458,2.184-0.728,3.133 c-2.444,8.557-8.557,23.232-25.67,17.119c-7.558-2.698-11.061-11.116-12.623-19.678c-1.059-5.815-1.219-11.69-1.142-15.889 c0.083-4.287,2.422-8.204,6.151-10.316c10.101-5.727,20.76-3.592,27.777-0.894C167.209,179.344,170.326,184.128,170.078,189.33 z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#01305A"
    },
    d: "M141.47,197.978c0,1.24-0.639,2.244-1.427,2.244c-0.788,0-1.427-1.005-1.427-2.244 c0-1.24,0.639-2.245,1.427-2.245C140.832,195.733,141.47,196.738,141.47,197.978z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#01305A"
    },
    d: "M159.092,197.978c0,1.24-0.639,2.244-1.427,2.244c-0.788,0-1.427-1.005-1.427-2.244 c0-1.24,0.639-2.245,1.427-2.245C158.453,195.733,159.092,196.738,159.092,197.978z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#01305A"
    },
    d: "M137.217,191.295c1.186-0.335,3.579-0.907,6.105-0.914c0.664-0.002,1.173,0.589,1.056,1.243 l-0.003,0.016c-0.094,0.522-0.561,0.892-1.091,0.867c-1.718-0.08-6.229,0.161-8.358,1.025c-0.044-0.37,0.175-0.776,0.485-1.136 C135.88,191.851,136.524,191.491,137.217,191.295z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#01305A"
    },
    d: "M160.274,191.341c-1.186-0.335-3.579-0.907-6.105-0.914c-0.664-0.002-1.173,0.589-1.056,1.243 l0.003,0.016c0.094,0.522,0.561,0.892,1.091,0.867c1.718-0.08,6.229,0.161,8.359,1.025c0.043-0.37-0.176-0.776-0.486-1.136 C161.611,191.897,160.966,191.537,160.274,191.341z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FB9E82"
    },
    d: "M149.199,208.219c-0.422,0-0.846-0.075-1.2-0.286c-0.323-0.193-0.723-0.584-0.802-1.347 c-0.21-2.028,0.309-8.384,0.331-8.653c0.025-0.303,0.291-0.53,0.595-0.505c0.303,0.025,0.53,0.292,0.505,0.595 c-0.005,0.065-0.533,6.523-0.333,8.449c0.035,0.335,0.171,0.454,0.271,0.514c0.518,0.31,1.714-0.007,2.213-0.209 c0.282-0.116,0.604,0.021,0.719,0.302c0.115,0.282-0.02,0.604-0.302,0.719C151.052,207.857,150.129,208.219,149.199,208.219z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M142.193,211.702c0.417,2.099,1.803,5.959,6.473,5.959c4.682,0,5.994-3.528,6.445-5.959H142.193 z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FB9E82"
    },
    d: "M148.599,220.881c-1.348,0-2.537-0.726-2.588-0.757c-0.259-0.16-0.34-0.5-0.179-0.76 c0.16-0.259,0.499-0.339,0.758-0.18l0,0c0.01,0.006,0.98,0.593,2.008,0.593c1.113,0,2.109-0.589,2.119-0.595 c0.261-0.156,0.6-0.072,0.757,0.188c0.157,0.26,0.074,0.599-0.186,0.756C151.237,220.157,150.027,220.881,148.599,220.881z"
  }))), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#01305A"
    },
    d: "M172.299,188.431c-0.178,0.503-0.669,0.825-1.328,1.017c0.048,1.217-0.08,2.68-0.2,4.083 c-0.681,7.974-2.692,9.374-3.147,7.402c-0.3-1.309-0.282-8.819-0.138-11.268c-1.576-0.104-2.922-0.366-2.922-0.366l-1.849-7.742 l-0.647,7.645c-2.774,0.965-9.247-0.581-9.247-0.581l-2.171-7.63l-1.342,7.342c-4.161,2.027-9.361,0.677-9.361,0.677 l-1.195-7.919l-2.759,7.919c0,0-8.877,3.184-8.973,0c-0.059-1.853,1.298-7.072,2.445-11.115 c1.25-4.409,4.146-8.133,8.063-10.234c11.011-5.91,22.654-2.767,26.649-0.381C172.647,172.337,172.299,188.431,172.299,188.431z "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#01305A"
    },
    d: "M132.164,172.352c0,0-7.563,8.691-9.967,24.215c-2.404,15.524-5.733,26.993,3.621,32.119 c10.124,5.548,12.075-3.899,11.928-6.992c-0.146-3.092-11.584-13.476-5.837-37.282 C133.764,176.726,132.164,172.352,132.164,172.352z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M170.21,209.511c0,0.714-0.579,1.293-1.293,1.293c-0.714,0-1.293-0.579-1.293-1.293 c0-0.714,0.579-1.293,1.293-1.293C169.631,208.219,170.21,208.797,170.21,209.511z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FDBEAB"
    },
    d: "M115.095,305.08c-1.901-29.024-6.854-52.755-4.42-55.821c1.062-1.343,2.833-2.792,5.019-4.276 C117.921,255.425,123.543,286.849,115.095,305.08z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FDBEAB"
    },
    d: "M187.323,266.998c-1.021,9.716-2.548,22.547-3.473,36.651 c-7.486-18.187-3.251-48.309-1.028-58.865c2.086,1.432,3.791,2.837,4.834,4.154C188.862,250.458,188.355,257.123,187.323,266.998 z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FDBEAB"
    },
    d: "M119.236,280.174l-8.421,27.049l-9.221,25.715c-1.483,5.383-7.426,8.154-12.502,5.836 c-0.089-0.04-0.177-0.08-0.266-0.12c-8.771-4.148-3.935-21.349-3.935-21.349l1.656-0.129c0.675-1.888,2.496-6.693,4.814-12.728 c0.28-0.742,0.573-1.506,0.871-2.278c0.493-1.283,1.004-2.607,1.523-3.966c0.742-1.919,1.506-3.899,2.278-5.894 c5.685-14.745,10.394-30.746,10.394-30.746l3.925-11.652L119.236,280.174z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FB9E82"
    },
    d: "M95.583,322.812c-0.037,0.005-0.069,0.005-0.106,0.005c-0.337,0.002-0.634-0.24-0.687-0.581 c-1.282-8.154-2.573-14.177-3.428-17.789c0.281-0.74,0.576-1.504,0.871-2.276c0.801,3.183,2.369,9.965,3.926,19.848 C96.217,322.397,95.961,322.749,95.583,322.812z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FDBEAB"
    },
    d: "M94.327,323.211c0,0-1.208-19.595-5.389-23.763c-4.181-4.168-7.998-5.757-11.92-5.615 c-3.921,0.142-7.61,0.628-7.368,2.241c0,0-9.007-1.361-13.029,0.973c-4.022,2.334,11.912,4.378,16.642,4.501 c4.731,0.123,7.229,2.766,7.421,5.586c0.191,2.82,2.921,21.494,2.921,21.494L94.327,323.211z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#001336"
    },
    d: "M99.098,297.341l-59.703,0.4c-2.245,0.015-4.078-1.793-4.093-4.038l0-0.035 c-0.015-2.245,1.793-4.078,4.038-4.093l59.703-0.4c2.245-0.015,4.078,1.793,4.093,4.038l0,0.035 C103.151,295.494,101.343,297.326,99.098,297.341z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#01305A"
    },
    d: "M35.343,297.768l-13.07-47.666c-0.734-2.677,1.269-5.323,4.046-5.341l28.057-0.188 c1.893-0.013,3.563,1.235,4.087,3.055l14.375,49.889L35.343,297.768z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#001336"
    },
    d: "M58.465,247.629l14.255,49.478l3.206-0.021l-14.255-49.478c-0.528-1.82-2.195-3.07-4.089-3.057 l-3.206,0.021C56.269,244.559,57.937,245.809,58.465,247.629z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3B73A9"
    },
    d: "M51.422,273.265c0.75,3.145-1.195,5.711-4.345,5.732c-3.15,0.021-6.311-2.511-7.061-5.656 c-0.75-3.145,1.195-5.711,4.345-5.732C47.511,267.588,50.673,270.121,51.422,273.265z"
  }))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#015288"
    },
    d: "M443.772,421.708v0.693c0,3.993-3.238,7.232-7.234,7.232H61.34c-3.996,0-7.232-3.239-7.232-7.232 v-0.693c0-3.993,3.236-7.232,7.232-7.232h375.198C440.534,414.476,443.772,417.715,443.772,421.708z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3B73A9"
    },
    d: "M443.772,421.708v0.346H54.108v-0.346c0-3.993,3.236-7.232,7.232-7.232h375.198 C440.534,414.476,443.772,417.715,443.772,421.708z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "DESIGNED_BY_FREEPIK"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_20_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_28_",
    style: {
      fill: "#112129"
    },
    d: "M260.104,465.465c-0.432,0.443-0.803,0.931-1.108,1.453l-0.465-0.241 c-0.067-0.298-0.349-0.503-0.659-0.466c-0.331,0.039-0.568,0.339-0.529,0.67c0.039,0.331,0.339,0.568,0.67,0.529 c0.065-0.008,0.127-0.026,0.183-0.052l0.452,0.234c-0.251,0.554-0.433,1.139-0.539,1.744l0.747,0.132 c0.23-1.306,0.85-2.507,1.792-3.473L260.104,465.465z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_27_",
    style: {
      fill: "#112129"
    },
    d: "M265.592,463.163c-0.171,0-0.341,0.006-0.51,0.017l-0.074-0.626 c0.188-0.149,0.296-0.389,0.266-0.645c-0.046-0.393-0.402-0.674-0.795-0.628c-0.393,0.046-0.674,0.402-0.628,0.795 c0.03,0.254,0.189,0.461,0.405,0.564l0.073,0.624c-0.714,0.116-1.403,0.332-2.06,0.646l0.327,0.684 c0.934-0.447,1.942-0.673,2.995-0.673c0.496,0,0.993,0.053,1.475,0.158l0.161-0.741 C266.692,463.222,266.142,463.163,265.592,463.163z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_26_",
    style: {
      fill: "#112129"
    },
    d: "M272.194,465.711c0.331-0.04,0.566-0.341,0.526-0.672 c-0.04-0.331-0.341-0.566-0.672-0.526c-0.309,0.038-0.535,0.304-0.53,0.609l-0.416,0.363c-0.418-0.43-0.89-0.813-1.408-1.139 l-0.404,0.641c1.134,0.715,2.021,1.726,2.563,2.925l0.691-0.313c-0.251-0.554-0.568-1.072-0.942-1.545l0.402-0.351 C272.065,465.716,272.129,465.719,272.194,465.711z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_25_",
    style: {
      fill: "#112129"
    },
    d: "M265.044,473.372c-0.386,0.023-0.775,0.035-1.157,0.035 c-0.88,0-1.733-0.061-2.478-0.179c-0.39-0.062-0.846-0.155-1.27-0.292c1.046,1.861,3.069,3.125,5.388,3.125 c2.855,0,5.262-1.916,5.95-4.504c-0.682,0.449-1.505,0.825-2.459,1.123C267.839,473.047,266.464,473.286,265.044,473.372z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_21_",
    style: {
      fill: "#112129"
    },
    d: "M265.592,464.68c-3.352,0-6.08,2.666-6.08,5.943c0,0.426,0.046,0.849,0.137,1.261 c0.673,0.483,2.706,0.89,5.348,0.731c2.879-0.173,5.297-0.957,6.672-2.159c-0.005-0.195-0.021-0.39-0.045-0.582 C271.244,466.913,268.65,464.68,265.592,464.68z M263.432,471.194c-1.02,0-1.85-0.83-1.85-1.85c0-1.02,0.83-1.85,1.85-1.85 c1.02,0,1.85,0.83,1.85,1.85C265.282,470.365,264.452,471.194,263.432,471.194z M268.17,470.286c-0.75,0-1.36-0.61-1.36-1.36 s0.61-1.361,1.36-1.361c0.75,0,1.361,0.61,1.361,1.361S268.92,470.286,268.17,470.286z"
  })), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_18_",
    style: {
      fill: "#112129"
    },
    d: "M281.595,466.547c-0.295-0.116-0.805-0.309-1.382-0.237 c-0.551,0.069-0.844,0.341-0.844,1.007v0.866h2.228v1.717h-2.228v5.455h-1.932v-5.455h-1.34v-1.717h1.34v-0.888 c0-1.68,0.896-2.783,2.568-2.783c0.643,0,1.157,0.122,1.59,0.308L281.595,466.547z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_16_",
    style: {
      fill: "#112129"
    },
    d: "M286.298,469.879c-0.177-0.03-0.358-0.046-0.526-0.046 c-0.896,0-1.51,0.548-1.51,1.614v3.908h-1.932v-7.172h1.873v0.785c0.451-0.673,1.14-0.977,2.021-0.977 c0.414,0,0.848,0.128,1.094,0.337L286.298,469.879z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_13_",
    style: {
      fill: "#112129"
    },
    d: "M293.965,471.757c0,0.222-0.015,0.489-0.037,0.651h-5.085 c0.207,1.036,0.933,1.488,1.843,1.488c0.622,0,1.295-0.252,1.813-0.688l1.132,1.243c-0.814,0.748-1.85,1.088-3.057,1.088 c-2.198,0-3.723-1.495-3.723-3.753c0-2.258,1.48-3.797,3.627-3.797C292.544,467.99,293.958,469.522,293.965,471.757z  M288.851,471.091h3.175c-0.177-0.918-0.733-1.436-1.562-1.436C289.554,469.655,289.021,470.203,288.851,471.091z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_10_",
    style: {
      fill: "#112129"
    },
    d: "M301.618,471.757c0,0.222-0.015,0.489-0.037,0.651h-5.085 c0.207,1.036,0.933,1.488,1.843,1.488c0.622,0,1.295-0.252,1.813-0.688l1.132,1.243c-0.814,0.748-1.85,1.088-3.057,1.088 c-2.198,0-3.723-1.495-3.723-3.753c0-2.258,1.48-3.797,3.627-3.797C300.197,467.99,301.611,469.522,301.618,471.757z  M296.504,471.091h3.175c-0.178-0.918-0.733-1.436-1.562-1.436C297.207,469.655,296.674,470.203,296.504,471.091z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_7_",
    style: {
      fill: "#112129"
    },
    d: "M309.964,471.764c0,2.154-1.495,3.775-3.471,3.775 c-0.962,0-1.643-0.378-2.109-0.933v3.708h-1.924v-10.133h1.887v0.792c0.466-0.585,1.155-0.984,2.139-0.984 C308.469,467.99,309.964,469.61,309.964,471.764z M304.287,471.764c0,1.132,0.747,1.976,1.843,1.976 c1.14,0,1.85-0.881,1.85-1.976c0-1.095-0.71-1.976-1.85-1.976C305.035,469.788,304.287,470.632,304.287,471.764z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_4_",
    style: {
      fill: "#112129"
    },
    d: "M313.068,465.836c0,0.696-0.54,1.229-1.236,1.229c-0.696,0-1.229-0.533-1.229-1.229 c0-0.696,0.533-1.243,1.229-1.243C312.527,464.592,313.068,465.14,313.068,465.836z M312.809,475.354h-1.932v-7.172h1.932 V475.354z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_2_",
    style: {
      fill: "#112129"
    },
    d: "M316.032,470.736l2.701-2.554h2.368l-3.479,3.375l3.501,3.797h-2.376l-2.716-2.901 v2.901H314.1v-10.658h1.932V470.736z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#112129"
    },
    d: "M184.412,475.289v-1.055c-0.527,0.718-1.391,1.23-2.387,1.23c-1.846,0-3.149-1.406-3.149-3.706 c0-2.256,1.289-3.721,3.149-3.721c0.952,0,1.816,0.469,2.387,1.245v-3.765h1.099v9.77H184.412z M184.412,473.37v-3.208 c-0.395-0.615-1.245-1.143-2.124-1.143c-1.421,0-2.27,1.172-2.27,2.739c0,1.567,0.85,2.724,2.27,2.724 C183.168,474.483,184.017,473.986,184.412,473.37z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#112129"
    },
    d: "M186.932,471.744c0-2.051,1.465-3.706,3.486-3.706c2.139,0,3.398,1.67,3.398,3.794v0.279h-5.727 c0.088,1.333,1.025,2.446,2.549,2.446c0.805,0,1.626-0.322,2.182-0.894l0.527,0.718c-0.703,0.703-1.655,1.084-2.812,1.084 C188.44,475.465,186.932,473.956,186.932,471.744z M190.403,468.947c-1.509,0-2.256,1.274-2.314,2.358h4.643 C192.718,470.25,192.015,468.947,190.403,468.947z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#112129"
    },
    d: "M194.607,474.351l0.571-0.791c0.469,0.542,1.362,1.011,2.329,1.011c1.084,0,1.67-0.513,1.67-1.216 c0-1.714-4.38-0.659-4.38-3.281c0-1.098,0.952-2.036,2.636-2.036c1.201,0,2.051,0.454,2.622,1.026l-0.513,0.762 c-0.424-0.513-1.201-0.894-2.109-0.894c-0.967,0-1.567,0.483-1.567,1.113c0,1.552,4.38,0.527,4.38,3.281 c0,1.187-0.952,2.138-2.783,2.138C196.306,475.465,195.325,475.113,194.607,474.351z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#112129"
    },
    d: "M201.477,466.471c0-0.41,0.337-0.747,0.732-0.747c0.41,0,0.747,0.337,0.747,0.747 c0,0.41-0.337,0.732-0.747,0.732C201.814,467.203,201.477,466.881,201.477,466.471z M201.667,475.289v-7.075h1.099v7.075H201.667 z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#112129"
    },
    d: "M204.582,477.105l0.556-0.82c0.586,0.703,1.289,0.967,2.3,0.967c1.172,0,2.27-0.571,2.27-2.124 v-1.011c-0.513,0.718-1.377,1.26-2.373,1.26c-1.845,0-3.149-1.377-3.149-3.662c0-2.27,1.289-3.677,3.149-3.677 c0.952,0,1.802,0.469,2.373,1.245v-1.069h1.098v6.87c0,2.344-1.641,3.076-3.369,3.076 C206.237,478.16,205.417,477.926,204.582,477.105z M209.709,473.253v-3.091c-0.381-0.615-1.23-1.143-2.109-1.143 c-1.421,0-2.27,1.128-2.27,2.695c0,1.553,0.849,2.695,2.27,2.695C208.478,474.41,209.328,473.868,209.709,473.253z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#112129"
    },
    d: "M217.413,475.289v-4.629c0-1.245-0.63-1.641-1.582-1.641c-0.865,0-1.685,0.527-2.095,1.099v5.17 h-1.099v-7.075h1.099v1.025c0.498-0.586,1.465-1.201,2.519-1.201c1.48,0,2.256,0.747,2.256,2.285v4.966H217.413z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#112129"
    },
    d: "M219.932,471.744c0-2.051,1.465-3.706,3.486-3.706c2.139,0,3.398,1.67,3.398,3.794v0.279h-5.727 c0.088,1.333,1.025,2.446,2.549,2.446c0.806,0,1.626-0.322,2.183-0.894l0.527,0.718c-0.703,0.703-1.655,1.084-2.812,1.084 C221.441,475.465,219.932,473.956,219.932,471.744z M223.404,468.947c-1.509,0-2.256,1.274-2.314,2.358h4.643 C225.718,470.25,225.015,468.947,223.404,468.947z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#112129"
    },
    d: "M233.35,475.289v-1.055c-0.527,0.718-1.392,1.23-2.388,1.23c-1.846,0-3.149-1.406-3.149-3.706 c0-2.256,1.289-3.721,3.149-3.721c0.952,0,1.817,0.469,2.388,1.245v-3.765h1.098v9.77H233.35z M233.35,473.37v-3.208 c-0.396-0.615-1.245-1.143-2.124-1.143c-1.421,0-2.27,1.172-2.27,2.739c0,1.567,0.849,2.724,2.27,2.724 C232.105,474.483,232.954,473.986,233.35,473.37z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#112129"
    },
    d: "M239.692,475.289v-9.77h1.098v3.765c0.572-0.776,1.421-1.245,2.388-1.245 c1.845,0,3.149,1.465,3.149,3.721c0,2.299-1.304,3.706-3.149,3.706c-0.996,0-1.86-0.513-2.388-1.23v1.055H239.692z  M242.9,474.483c1.436,0,2.285-1.157,2.285-2.724c0-1.568-0.85-2.739-2.285-2.739c-0.864,0-1.728,0.527-2.109,1.143v3.208 C241.171,473.986,242.036,474.483,242.9,474.483z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#112129"
    },
    d: "M247.528,477.061c0.161,0.073,0.425,0.117,0.601,0.117c0.483,0,0.805-0.161,1.055-0.747 l0.469-1.069l-2.959-7.148h1.187l2.358,5.8l2.344-5.8h1.201l-3.545,8.51c-0.425,1.025-1.143,1.421-2.08,1.435 c-0.234,0-0.601-0.044-0.806-0.103L247.528,477.061z"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAboutUsIllustration);
export default __webpack_public_path__ + "static/media/aboutUs_illustration.3f7b1dbdd3286eaea1efc0faeb1dd760.svg";
export { ForwardRef as ReactComponent };